/**
 * Bottom of the visible viewport in layout-viewport coordinates — the boundary
 * to compare `getBoundingClientRect()` values against. Rects are in
 * layout-viewport coordinates, so the visible bottom is the visual viewport's
 * offset within it plus its height (pinch zoom and keyboard panning make
 * `offsetTop` nonzero).
 */
export function getVisualViewportBottom(): number {
  const viewport = window.visualViewport;
  return viewport ? viewport.offsetTop + viewport.height : window.innerHeight;
}
